<template>
  <div class="attribute-item-row my-3 d-flex">
    <div
      v-for="attribute in mainRequestDisplayItems"
      :key="attribute.key"
      class="attribute-item pa-1"
    >
      <div class="attribute-item-title">
        {{ attribute.displayName }}
      </div>
      <div class="attribute-item-value">
        {{ attribute.formatter? attribute.formatter(requestInfo.mainRequest[attribute.key]):requestInfo.mainRequest[attribute.key] }}
      </div>
    </div>

    <request-stepper
      :current-step="requestInfo.mainRequest.requestStep"
      class="align-items-center"
    ></request-stepper>
  </div>
</template>

<script>
import { toHijriDate } from '@/helpers/utils';
import RequestStepper from './request-stepper.vue';
import { mainRequestStep, subRequestStatus, subRequestType } from '../../helpers/enum';

export default {
  name: 'SubRequestSummary',
  components: { RequestStepper },
  props: {
    requestInfo: {
      type: Object,
      required: true,
    },
  },
  data() { return { toHijriDate }; },
  computed: {
    mainRequestHeaders() {
      return [
        {
          key: 'requestCategoryName',
          displayName: this.local.bankruptcy.bankruptcyFile.requestCategoryName,
        },
        {
          key: 'legalCapacityName',
          displayName: this.local.bankruptcy.bankruptcyFile.legalCapacityName,
        },
        {
          key: 'requestOwnerTypeName',
          displayName: this.local.bankruptcy.bankruptcyFile.onBehalfOf,
        },
        {
          key: 'courtName',
          displayName: this.local.bankruptcy.bankruptcyFile.courtName,
        },
        {
          key: 'openedProcedureName',
          displayName: this.local.bankruptcy.bankruptcyFile.openedProcedureName,
        },
        {
          key: 'openedProcedureDate',
          displayName: this.local.bankruptcy.bankruptcyFile.openedProcedureDate,
          formatter: toHijriDate,
        },

      ];
    },
    mainRequestDisplayItems() {
      return this.mainRequestHeaders.map((prop) => {
        prop.value = this.requestInfo.mainRequest[prop.key];
        return prop;
      }).filter(item => item.value);
    },
  },
  watch: {},
  mounted() {
    this.updateSubRequestInfoCurrentStep();
  },
  methods: {
    updateSubRequestInfoCurrentStep() {
      if (this.requestInfo.requestTypeId == subRequestType.EndProcedureRequest && this.requestInfo.statusId == subRequestStatus.accepted)
        this.requestInfo.mainRequest.requestStep = mainRequestStep.done;
    },
  },
};
</script>

<style lang="scss" scoped>
.attribute-item-row {
  display: flex;
  justify-content: space-between;
  position: relative;
  border: 1px solid #dbdbdb;
}

.attribute-item {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding: 0 10px 0 10px;
}

.attribute-item-title {
  font-size: 14px;
  font-weight: bold;
  color: #158e8d;
}

.attribute-item-value {
  font-weight: bolder;
  font-size: 16px;
  color: #02363d;
}
</style>
